var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.1114e-09 12C-1.38717e-09 5.35 5.35 1.38717e-09 12 3.1114e-09C18.65 4.83563e-09 24 5.35 24 12C24 18.65 18.65 24 12 24C5.35 24 -4.83563e-09 18.65 -3.1114e-09 12ZM13.5004 7.55017C13.5004 6.70017 12.8504 6.05017 12.0004 6.05017C11.1504 6.05017 10.5004 6.70017 10.5004 7.55017C10.5004 8.40017 11.1504 9.05017 12.0004 9.05017C12.8504 9.05017 13.5004 8.40017 13.5004 7.55017ZM14.0009 17.0002C14.3009 17.0002 14.5009 16.8002 14.5009 16.5502L14.5009 15.5502C14.5009 15.2502 14.2509 15.0002 14.0009 15.0002C13.7009 15.0002 13.5009 14.8002 13.5009 14.5502L13.5009 10.5502C13.5009 10.2502 13.2509 10.0002 13.0009 10.0002L10.0009 10.0002C9.7009 10.0002 9.5009 10.3002 9.5009 10.5502L9.5009 11.5502C9.5009 11.8502 9.7509 12.0002 10.0009 12.0002C10.3009 12.0002 10.5009 12.3002 10.5009 12.5502L10.5009 14.5502C10.5009 14.8502 10.2509 15.0002 10.0009 15.0002C9.7009 15.0002 9.5009 15.3002 9.5009 15.5502L9.5009 16.5502C9.5009 16.8502 9.7509 17.0002 10.0009 17.0002L14.0009 17.0002Z",
    fill: "#0063B5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Union.1391cffc4821c8454ef49434a552c604.svg";